import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import blueIcon from '../../assets/img/blue_icon.webp';

interface ViewDetailsActionProps {
  item: {
    id: number;
    original_rarity?: string;
    is_product?: boolean;
    d2rshopproductlink?: string;
  };
  size?: 'small' | 'medium' | 'large';
  sx?: any;
}

export default function ViewDetailsAction({
  item,
  size = 'small',
  sx = {},
}: ViewDetailsActionProps) {
  const { t } = useTranslation();

  const handleViewDetails = () => {
    // Always open the item detail page, not the shop link
    // This is the original "View Details" functionality
    window.open(
      item.original_rarity === 'RUNE' ? `/product/${item.id}` : `/item/${item.id}`,
      '_blank'
    );
  };

  return (
    <Tooltip title={t('search.vendor.viewDetails', 'View Details')}>
      <IconButton
        onClick={handleViewDetails}
        size={size}
        sx={{
          color: (theme) => theme.palette.text.secondary,
          border: (theme) => `1px solid ${theme.palette.secondary.main}33`,
          '&:hover': {
            color: (theme) => theme.palette.text.primary,
            border: (theme) => `1px solid ${theme.palette.secondary.main}`,
          },
          ...sx,
        }}
      >
        <img src={blueIcon} alt="details" style={{ width: '20px', height: '20px' }} />
      </IconButton>
    </Tooltip>
  );
}
